<template>
  <div class="maps">
    <span class="title">地图导航</span>
    <div class="content">
      <img :src="name" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: null,
    }
  },
  created() {
    // console.log(this.$route.query.area_name);
    this.name = require('../../../assets/img/乡镇地图/' +
      this.$route.query.area_name +
      '.png')
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {},
}
</script>

<style scoped>
.maps {
  /* padding: 0 37px; */
  /* width: 484px; */
  width: 1000px;
  height: 497px;
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1);
}

.title {
  display: block;
  padding: 0 37px;
  width: 90%;
  height: 80px;
  border-bottom: 1px solid #dbdbdb;

  font-size: 37px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2187ff;
  line-height: 80px;
}

.content {
  /* margin: 0 auto; */
  margin-top: 10px;
  display: block;
  width: 800px;
  height: 391px;
  position: relative;
  background-size: 100% 100%;
}

.content img {
  display: block;
  margin: 0 90px;
  width: auto;
  height: 100%;
}
</style>
